export default "__VITE_ASSET__RxJ$BTp7__"